
// import React from 'react';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';

// function ProfileSideBar() {
//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-6 mx-auto">

//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>

//       {/* Navigation Links */}
//       <div className="space-y-2">
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//       </div>

//       {/* Logout Button */}
//       <button className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100">
//         Logout
//       </button>
//     </div>
//   );
// }

// export default ProfileSideBar;

// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';

// function ProfileSideBar() {
//   const navigate = useNavigate(); // Hook for navigation

//   const handleLogout = () => {
//     // Perform any logout-related tasks (e.g., clearing user data)
//     // Then redirect to the login page
//     navigate('/login'); 
//   };

//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-6 mx-auto">

//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>

//       {/* Navigation Links */}
//       <div className="space-y-2">
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//         <div className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//       </div>

//       {/* Logout Button */}
//       <button 
//         className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100"
//         onClick={handleLogout} // Handle click event
//       >
//         Logout
//       </button>
//     </div>
//   );
// }

// export default ProfileSideBar;


// import React from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';

// function ProfileSideBar() {
//   const navigate = useNavigate(); // Hook for navigation

//   const handleLogout = () => {
//     // Perform any logout-related tasks (e.g., clearing user data)
//     // Then redirect to the login page
//     navigate('/login'); 
//   };

//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-6 mx-auto border ">

//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>

//       {/* Navigation Links */}
//       <div className="space-y-2">
//         <Link to="/profile/myprofile" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/myride" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/my-booking" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Bookings</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/notification" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/my-referal" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/wallet-amt" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//       </div>

//       {/* Logout Button */}
//       <button 
//         className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100"
//         onClick={handleLogout} // Handle click event
//       >
//         Logout
//       </button>
//     </div>
//   );
// }

// export default ProfileSideBar;


// import React, { useEffect } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';

// function ProfileSideBar() {
//   const navigate = useNavigate(); // Hook for navigation
//   const location = useLocation(); // Current URL location

//   useEffect(() => {
//     if (location.pathname === '/profile') {
//       navigate('/profile/myprofile');
//     }
//   }, [location, navigate]);

//   const handleLogout = () => {
//     navigate('/logout');
//   };

//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg  mx-auto border ">
//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>

//       {/* Navigation Links */}
//       <div className="space-y-2">
//         <Link to="/profile/myprofile" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/myride" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/my-booking" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Bookings</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/notification" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/my-referal" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile/wallet-amt" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//       </div>

//       {/* Logout Button */}
//       <button
//         className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100"
//         onClick={handleLogout} // Handle click event
//       >
//         Logout
//       </button>
//     </div>
//   );
// }

// export default ProfileSideBar;


import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen, FaChevronRight } from 'react-icons/fa';

function ProfileSideBar() {
  const navigate = useNavigate(); // Hook for navigation
  const location = useLocation(); // Current URL location

  useEffect(() => {
    if (location.pathname === '/profile') {
      navigate('/profile/myprofile');
    }
  }, [location, navigate]);

  const handleLogout = () => {
    navigate('/logout');
  };

  return (
    <div className="w-full max-w-sm bg-white rounded-lg  mx-auto border">
      {/* Profile Section */}
      <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 rounded-lg  bg-gray-100">
        <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
          R
        </div>
        <h2 className="mt-2 font-semibold">Ranjita</h2>
        <p className="text-sm text-gray-500">Name as per DL</p>
      </div>

      {/* Navigation Links */}
      <div className="space-y-2 p-2">
        <Link to="/profile/myprofile" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
          <FaUserFriends className="mr-3" />
          <span className="flex-start font-normal">My Profile</span>
          <FaChevronRight className="text-gray-400 ml-auto text-sm" />
        </Link>
        <Link to="/profile/myride" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
          <FaMotorcycle className="mr-3" />
          <span className="flex-start">My Ride</span>
          <FaChevronRight className="text-gray-400 ml-auto text-sm" />
        </Link>
        <Link to="/profile/my-booking" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
          <FaMotorcycle className="mr-3" />
          <span className="flex-start">My Bookings</span>
          <FaChevronRight className="text-gray-400 ml-auto text-sm" />
        </Link>
        <Link to="/profile/notification" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
          <FaBell className="mr-3" />
          <span className="flex-start">Notifications</span>
          <FaChevronRight className="text-gray-400 ml-auto text-sm" />
        </Link>
        <Link to="/profile/my-referal" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
          <FaUserFriends className="mr-3" />
          <span className="flex-start">My Referrals</span>
          <FaChevronRight className="text-gray-400 ml-auto text-sm" />
        </Link>
        <Link to="/profile/wallet-amt" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
          <FaWallet className="mr-3" />
          <span className="flex-start">Wallet</span>
          <FaChevronRight className="text-gray-400 ml-auto text-sm" />
        </Link>
        <Link to="/" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
          <FaFolderOpen className="mr-3" />
          <span className="flex-start">My Case</span>
          <FaChevronRight className="text-gray-400 ml-auto text-sm" />
        </Link>
      </div>

      {/* Logout Button */}
      <button
        className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100"
        onClick={handleLogout} // Handle click event
      >
        Logout
      </button>
    </div>
  );
}

export default ProfileSideBar;
